import { render, staticRenderFns } from "./TransferContract.vue?vue&type=template&id=ee3bca4a&scoped=true"
import script from "./TransferContract.vue?vue&type=script&lang=js"
export * from "./TransferContract.vue?vue&type=script&lang=js"
import style0 from "./TransferContract.vue?vue&type=style&index=0&id=ee3bca4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3bca4a",
  null
  
)

export default component.exports